(function () {
  'use strict';

  var ACCEPTED_EXTENSIONS = [
    'ai', 'pdf', 'eps', 'svg', 'psd', 'png', 'jpg', 'jpeg', 'tif', 'tiff'
  ];

  function extensionFor(file) {
    var parts = String(file && file.name || '').toLowerCase().split('.');
    return parts.length > 1 ? parts.pop() : '';
  }

  function focusableElements(container) {
    return Array.from(container.querySelectorAll(
      'button:not([disabled]), [href], input:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (element) {
      return !element.hidden && element.offsetParent !== null;
    });
  }

  function initializeModal(modal) {
    if (modal.dataset.zugBannerUploadReady === 'true') return;
    modal.dataset.zugBannerUploadReady = 'true';

    var formId = modal.dataset.formId;
    var recipeKey = modal.dataset.recipeKey || 'banner';
    var isMultiLocation = modal.dataset.zugBannerMultiLocation === 'true';
    var form = document.getElementById(formId);
    var error = modal.querySelector('[data-zug-banner-upload-error]');
    var save = modal.querySelector('[data-zug-banner-upload-save]');
    var notes = modal.querySelector('[data-zug-banner-order-notes]');
    var closeButtons = Array.from(modal.querySelectorAll('[data-zug-banner-upload-close]'));
    var opener = null;
    var homeParent = modal.parentNode;
    var homeNextSibling = modal.nextSibling;
    var locationElements = isMultiLocation
      ? Array.from(modal.querySelectorAll('[data-zug-banner-artwork-location]'))
      : [modal];
    var locations = locationElements.map(function (element) {
      return {
        element: element,
        key: isMultiLocation ? element.dataset.zugBannerArtworkLocation : 'primary',
        title: isMultiLocation && element.querySelector('h4')
          ? element.querySelector('h4').textContent.trim()
          : 'Artwork',
        required: isMultiLocation ? element.dataset.zugBannerLocationRequired === 'true' : true,
        method: isMultiLocation ? '' : 'upload',
        methods: Array.from(element.querySelectorAll('[data-zug-banner-artwork-method]')),
        uploadPanel: element.querySelector('[data-zug-banner-upload-panel]'),
        dropzone: element.querySelector('[data-zug-banner-dropzone]'),
        input: element.querySelector('[data-zug-banner-file-input]'),
        summary: element.querySelector('[data-zug-banner-file-summary]'),
        filename: element.querySelector('[data-zug-banner-file-name]'),
        remove: element.querySelector('[data-zug-banner-file-remove]'),
        replace: element.querySelector('[data-zug-banner-file-replace]')
      };
    });

    function showError(message) {
      error.textContent = message || '';
      error.hidden = !message;
    }

    function locationComplete(location) {
      if (!location.required) return true;
      if (!location.method) return false;
      return location.method === 'later' ||
        Boolean(location.input.files && location.input.files[0]);
    }

    function updateSave() {
      save.disabled = !locations.every(locationComplete);
    }

    function updateLocation(location) {
      var file = location.input.files && location.input.files[0];
      location.summary.hidden = !file;
      location.filename.textContent = file ? file.name : '';
      location.uploadPanel.hidden = !location.required || location.method !== 'upload';
      location.input.disabled = !location.required || location.method !== 'upload';
      location.methods.forEach(function (button) {
        var selected = button.dataset.zugBannerArtworkMethod === location.method;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-checked', selected ? 'true' : 'false');
        button.disabled = !location.required;
      });
      if (isMultiLocation) {
        location.element.hidden = !location.required;
        location.element.classList.remove('is-unresolved');
      }
      updateSave();
    }

    function clearFile(location) {
      location.input.value = '';
      updateLocation(location);
    }

    function chooseMethod(location, nextMethod) {
      location.method = nextMethod === 'later' ? 'later' : 'upload';
      updateLocation(location);
      showError('');
    }

    function setLocationRequired(key, required) {
      var location = locations.find(function (candidate) {
        return candidate.key === key;
      });
      if (!location) return;
      location.required = Boolean(required);
      location.element.dataset.zugBannerLocationRequired = location.required ? 'true' : 'false';
      updateLocation(location);
    }

    function openModal(event) {
      opener = event && event.detail && event.detail.opener
        ? event.detail.opener
        : (event && event.currentTarget ? event.currentTarget : document.activeElement);
      if (isMultiLocation) {
        setLocationRequired('back', modal.dataset.requiresBack === 'true');
        locations.forEach(updateLocation);
      } else {
        chooseMethod(
          locations[0],
          form && form.elements['properties[_banner_artwork_mode]'] &&
            form.elements['properties[_banner_artwork_mode]'].value === 'email_later'
            ? 'later'
          : 'upload'
        );
      }
      if (isMultiLocation && modal.parentNode !== document.body) {
        document.body.appendChild(modal);
      }
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      var focusables = focusableElements(modal);
      if (focusables[0]) focusables[0].focus();
    }

    function closeModal() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (isMultiLocation && homeParent) {
        if (homeNextSibling && homeNextSibling.parentNode === homeParent) {
          homeParent.insertBefore(modal, homeNextSibling);
        } else {
          homeParent.appendChild(modal);
        }
      }
      if (opener && typeof opener.focus === 'function') opener.focus();
    }

    function acceptFiles(location, files) {
      if (!files || !files[0]) return;
      var file = files[0];
      if (ACCEPTED_EXTENSIONS.indexOf(extensionFor(file)) === -1) {
        showError('Choose an AI, PDF, EPS, SVG, PSD, PNG, JPG, TIF or TIFF file.');
        return;
      }

      try {
        var transfer = new DataTransfer();
        transfer.items.add(file);
        location.input.files = transfer.files;
      } catch (exception) {
        showError('Your browser could not attach that file. Use the Browse option instead.');
        return;
      }
      updateLocation(location);
      showError('');
    }

    locations.forEach(function (location) {
      location.methods.forEach(function (button) {
        button.addEventListener('click', function () {
          chooseMethod(location, button.dataset.zugBannerArtworkMethod);
        });
      });

      location.dropzone.addEventListener('click', function () {
        location.input.click();
      });
      location.dropzone.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        location.input.click();
      });
      location.dropzone.addEventListener('dragover', function (event) {
        event.preventDefault();
        location.dropzone.classList.add('is-dragging');
      });
      location.dropzone.addEventListener('dragleave', function () {
        location.dropzone.classList.remove('is-dragging');
      });
      location.dropzone.addEventListener('drop', function (event) {
        event.preventDefault();
        location.dropzone.classList.remove('is-dragging');
        acceptFiles(location, event.dataTransfer.files);
      });
      location.input.addEventListener('change', function () {
        updateLocation(location);
        showError('');
      });
      location.remove.addEventListener('click', function () {
        clearFile(location);
      });
      location.replace.addEventListener('click', function () {
        location.input.click();
      });
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeModal);
    });
    modal.addEventListener('zug-banner:open', openModal);

    save.addEventListener('click', function () {
      var unresolved = locations.filter(function (location) {
        return !locationComplete(location);
      });
      locations.forEach(function (location) {
        if (isMultiLocation) {
          location.element.classList.toggle('is-unresolved', unresolved.indexOf(location) !== -1);
        }
      });
      if (unresolved.length) {
        showError('Choose Upload Artwork or Upload Later for ' + unresolved[0].title + '.');
        return;
      }

      var details = {};
      locations.forEach(function (location) {
        var file = location.input.files && location.input.files[0];
        if (!location.required) return;
        if (!isMultiLocation && location.method === 'later') clearFile(location);
        details[location.key] = {
          mode: location.method === 'upload' ? 'upload_artwork' : 'email_later',
          label: location.method === 'upload' ? 'Uploaded' :
            (recipeKey !== 'banner' ? 'Upload Later' : 'Email Artwork Later'),
          filename: location.method === 'upload' && file ? file.name : ''
        };
      });
      if (notes) notes.name = notes.value.trim() === '' ? '' : 'properties[Order Notes]';

      var primaryDetail = details.primary || details.front || details[locations[0].key];
      modal.dispatchEvent(new CustomEvent('zug-banner:artwork-saved', {
        bubbles: true,
        detail: {
          mode: primaryDetail.mode,
          label: primaryDetail.label,
          filename: primaryDetail.filename,
          locations: details,
          notes: notes ? notes.value.trim() : ''
        }
      }));
      closeModal();
    });

    if (notes) {
      notes.addEventListener('input', function () {
        notes.name = 'properties[Order Notes]';
      });
    }
    modal.addEventListener('zug-banner:configuration-reset', function () {
      locations.forEach(function (location) {
        location.method = isMultiLocation ? '' : 'upload';
        clearFile(location);
      });
      if (notes) {
        notes.value = '';
        notes.name = '';
      }
      showError('');
    });
    modal.addEventListener('zug-banner:artwork-requirements', function (event) {
      if (!isMultiLocation) return;
      var requiresBack = Boolean(event.detail && event.detail.requiresBack);
      modal.dataset.requiresBack = requiresBack ? 'true' : 'false';
      setLocationRequired('back', requiresBack);
    });

    modal.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
        return;
      }

      if (event.key !== 'Tab') return;
      var focusables = focusableElements(modal);
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    document.querySelectorAll('[data-zug-banner-open-upload="' + modal.id + '"]').forEach(function (button) {
      button.addEventListener('click', openModal);
    });

    locations.forEach(updateLocation);
  }

  function initializeAll() {
    document.querySelectorAll('[data-zug-banner-upload-modal]').forEach(initializeModal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', initializeAll);
})();
